import { useState } from 'react'
import Items from './Items.js'
import { projects } from '../Data.jsx';
import { ReactComponent as Curve } from '../assets/curve_right.svg';

const Projects = () => {
  const [projectItems] = useState(projects);

  return (
    <section className="section-bg-b1 section pb-[50px]" id="work">
      <div className="container grid grid-cols-1 lg:grid-cols-[5fr_5fr] gap-5 lg:gap-10 lg:gap-[100px] mt-[10px] px-2 lg:px-16 relative">
        {/* Left Column */}
        <div className="flex flex-col gap-5 lg:gap-10 lg:align-left">
          <div className="text-center lg:text-left">
            <h2 className="text-[clamp(1.75rem,_1.5rem_+_1.5vw,_2.5rem)] font-bold text-title mb-2 lg:mb-8 relative inline-block">Projects</h2>
            <p className="text-normal font-body leading-relaxed lg:w-[80%] mb-4 lg:mb-8 text-text text-center lg:text-left opacity-80">
              Projects showcasing my hands-on experience in full-stack development, system design, and problem-solving, with a strong focus on real-world implementation and reliability.
            </p>
          </div>
          <Items projectItems={projectItems.slice(0, 1)} />
        </div>


        {/* Decorative Curve Arrow */}
        <div className="hidden min-[1400px]:block absolute left-[38%] top-[25%] z-0 opacity-60 text-primary pointer-events-none">
          <Curve className="w-[20vw] h-[20vw] fill-current rotate-6" />
        </div>

        {/* Right Column */}
        <div className="flex flex-col gap-5 lg:gap-10">
          <Items projectItems={projectItems.slice(1, 3)} className="lg:ml-auto" />
        </div>
      </div>
    </section>
  )
}

export default Projects